"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultCardRenderer = void 0;

var _react = _interopRequireDefault(require("react"));

var _context = require("../../context");

var _layout = require("../../layout");

var _text = require("../../text");

var _utils = require("../../utils");

var _utils2 = require("../utils");

var _core = require("@emotion/core");

var DataList = _layout.Col.withComponent('ul', {
  target: "end8bh90"
});

DataList.displayName = 'DataList';

var DataListItem = _layout.Col.withComponent('li', {
  target: "end8bh91"
});

DataListItem.displayName = 'DataListItem';
var ScreenReaderOnlyListText = (0, _context.styledWithTheme)('div')({
  position: 'absolute',
  opacity: 0,
  right: 0,
  left: 0,
  top: 0,
  bottom: 0,
  pointerEvents: 'none'
});
var UlList = (0, _context.styledWithTheme)('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0
});
var ListItem = (0, _context.styledWithTheme)('li')(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: 0,
    margin: 0,
    position: 'relative',
    marginBottom: (0, _utils.px)(theme.selectors.space('S200')),
    ':last-child': {
      marginBottom: 0
    }
  };
});

var defaultCardRenderer = function defaultCardRenderer(_ref2) {
  var columns = _ref2.columns,
      useCellComponents = _ref2.useCellComponents;
  return function (_ref3) {
    var data = _ref3.data,
        index = _ref3.index;
    return (0, _core.jsx)(UlList, {
      role: "list"
    }, columns.map(function (_ref4, colIndex) {
      var header = _ref4.header,
          accessor = _ref4.accessor,
          Cell = _ref4.cellComponent;
      var columnData = (0, _utils2.applyAccessor)(accessor, data, index);
      return (0, _core.jsx)(ListItem, {
        key: "".concat(index, "-").concat(colIndex)
      }, !!Cell && useCellComponents ? (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_text.Text, {
        fontSize: "T100",
        color: "neutral70"
      }, header), (0, _core.jsx)(Cell, {
        data: columnData,
        index: index
      })) : (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_text.Text, {
        "aria-hidden": "true",
        fontSize: "T100",
        color: "neutral70"
      }, header), (0, _core.jsx)(_text.Text, {
        "aria-hidden": "true",
        fontSize: "T100",
        color: "neutral90"
      }, columnData), (0, _core.jsx)(ScreenReaderOnlyListText, null, header, ", ", columnData)));
    }));
  };
};

exports.defaultCardRenderer = defaultCardRenderer;